<div class="package-detail-modal-wrapper">
    <div class="package-detail-modal">
        <div class="package-detail-header">
            <span>
            <img src="./assets/icons/appt-preview/arrow.svg" class="back-icon cursor-pointer" (click)="onBack()" />

            <span class="header-title">
                {{isMobileView && mobileScreen === 2 ? ('Service_details' | translate) : ('My_packages' | translate)}}
            </span>
            </span>

            <span class="close-icon cursor-pointer" (click)="closeModal()">
                <img src="./assets/icons/close_black.svg" />
            </span>
        </div>

        <div class="package-detail-body" [ngClass]="{ 'mobile-screen-1': isMobileView && mobileScreen === 1, 'mobile-screen-2': isMobileView && mobileScreen === 2}">
            
            <div class="left-two-columns">
            <section class="package-column package-column-left">
                <div class="package-card">
                    <div class="package-image-wrapper" *ngIf="selectedPackage?.imageURL">
                        <img class="package-image" [src]="selectedPackage.imageURL" />
                    </div>

                    <div class="package-main-content">
                        <div class="package-main-subcontent">
                            <p class="package-name">{{ selectedPackage?.name }}</p>

                            <p class="package-purchased"> {{ 'Purchased_on' | translate }}: {{selectedPackage?.bookedDttm | moment : 'D MMM YYYY, hh:mm A' : 'YYYY-MM-DD HH:mm:ss'}}
                            </p>
                        </div>
                        <div class="package-main-subcontent">
                            <div class="my-packge-html" *ngIf="selectedPackage?.['_healthPackage']?.detail.length > 0 && selectedPackage?.['_healthPackage']?.detail[0]?.packageContent !== '<html></html>'">
                                <div class="innerImg type-image" [innerHTML]="getPackageContent(selectedPackage['_healthPackage']['detail'])"></div>
                            </div>
                            <!-- <div class="package-description" [innerHTML]="getPackageContent(selectedPackage?._healthPackage?.detail)"></div> -->
                            <p class="section-header-title">{{ 'Services_included' | translate }}</p>

                            <div class="services-list">
                                <ng-container
                                    *ngFor="let services of selectedPackage?._healthPackage?.packageDtls?.servicesApplicable">
                                    <div class="service-item" *ngIf="(services | translate : 'PACKAGEOBJ') as service; else NOCONCEPT">
                                        <img *ngIf="service._directiveRef?.imageUrl" [src]="service._directiveRef.imageUrl" class="service-icon" alt="Service Icon" />
                                        <label class="service-label">{{ service.name | translate : 'LOCALE' : 'name'}}</label>
                                    </div>
                                    <ng-template #NOCONCEPT>
                                        <div class="service-item">
                                            <img src="./assets/icon/dashboard/package.svg" class="service-icon" alt="Default Icon" />
                                            <label class="service-label">{{ services.directiveCode + ' - ' + services.conceptCode }}</label>
                                        </div>
                                    </ng-template>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="package-column package-column-middle">
                <div class="info-card-header">
                    {{ 'Payment_details' | translate }}
                </div>
                <div class="info-card">
                    <div class="info-card-body">
                        <div class="info-row">
                            <span class="info_label">{{ 'Purchased_on' | translate }}</span>
                            <span class="info_value">{{selectedPackage?.bookedDttm | moment : 'D MMM YYYY, hh:mm A' : 'YYYY-MM-DD HH:mm:ss'}}</span>
                        </div>

                        <div class="info-row" *ngIf="selectedPackage?.orderedBy">
                            <span class="info_label">{{ 'Purchased_for' | translate }}</span>
                            <span class="info_value">{{ selectedPackage?.orderedBy }}</span>
                        </div>

                        <div class="info-row" *ngIf="!selectedPackage?.cancelledDateTm">
                            <span class="info_label">{{ 'Valid_from' | translate }}</span>
                            <span class="info_value" *ngIf="selectedPackage?.validFrom">{{ (selectedPackage?.validFrom || '')| moment : 'D MMM YYYY' : 'YYYY-MM-DD HH:mm:ss' }}</span>
                        </div>

                        <div class="info-row" *ngIf="!selectedPackage?.cancelledDateTm">
                            <span class="info_label">{{ 'Valid_till' | translate }}</span>
                            <span class="info_value" *ngIf="selectedPackage?.validTo">{{ (selectedPackage?.validTo || '')| moment : 'D MMM YYYY' : 'YYYY-MM-DD HH:mm:ss'}}</span>
                        </div>

                        <div class="info-row" *ngIf="selectedPackage?.cancelledDateTm">
                            <span class="info_label">{{ 'cancelled' | translate }}</span>
                            <span class="info_value" *ngIf="selectedPackage?.cancelledDateTm">{{ (selectedPackage?.cancelledDateTm || '')| moment : 'D MMM YYYY' : 'YYYY-MM-DD HH:mm:ss'}}</span>
                        </div>

                        <div class="info-row">
                            <span class="info_label">{{ 'facility' | translate }}</span>
                            <span class="info_value">{{ selectedPackage?.facilityId | facilityDetails : 'facilityName'| translate : 'LOCALE' : 'name' }}</span>
                        </div>

                        <div class="info-row" *ngIf="modeOfServiceLabel">
                            <span class="info_label">{{ 'Mode_of_service' | translate }}</span>
                            <span class="info_value">{{ modeOfServiceLabel }}</span>
                        </div>
                    </div>
                    <div class="footer-block" *ngIf="isMobileView && mobileScreen === 1">
                        <button class="primary-btn" (click)="goToServiceDetails()">{{ 'pkg_details_continue' | translate}}
                    </button>
                    </div>
                </div>
            </section>
            </div>

            <section class="package-column package-column-right separate-scroll">
                <div class="right-scroll-area">
                    <div class="info-card-header">{{ 'Service_details' | translate }}
                </div>
                <div class="service-info-card service-details-card">
                    <div class="mapped-service-list">
                        <div class="service-card" *ngFor="let groupedService of groupedServices">
                            <div class="service-header" [class.with-border]="footerApplicableStatus.includes(selectedPackage?.packageStatusFromTab)">
                                <div class="left-col">
                                    <p class="service-title">
                                        {{ (groupedService.groupName || (groupedService.includedServices[0] | translate:'PACKAGEOBJ':null:null:groupedService.firstService).name ) | translate:'LOCALE':'name' }}
                                    </p>

                                    <button class="included-services-btn" *ngIf="groupedService.isAppointmentGrouped"
                                        (click)="showIncludedServices(groupedService)">
                                        <img src="assets/icons/slot/info.svg" />
                                        <span>{{ 'HEALTHPKG#SUBTITLE#TEXT#INCLUDEDSERVICES' | translate }}</span>
                                    </button>
                                </div>

                                <button class="manage-btn" *ngIf="groupedService.canManageAppt"
                                    (click)="openAppointmentDetails(groupedService)">
                                    {{ 'HEALTHPKG#BTN#TEXT#MANAGE' | translate }}
                                </button>
                            </div>

                            <div class="service-footer" *ngIf="footerApplicableStatus.includes(selectedPackage.packageStatusFromTab)">

                                <div *ngIf="!groupedService.isAppointmentBooked" class="footer-row">
                                    <p class="note" *ngIf="!groupedService.canBookAppointment">
                                        {{ 'HEALTHPKG#CARD#TEXT#COMPLETEPREVAPPT' | translate }}
                                    </p>
                                    <button class="book-btn" *ngIf="groupedService.canBookAppointment"
                                        (click)="bookSubservice(groupedService.firstService, translatedPkgObj(groupedService) , groupedService)">
                                        {{ 'my_package_view_detail_book_appt' | translate }}
                                        <img src="assets/icons/slot/right_arrow.svg" />
                                    </button>
                                </div>
                                <div *ngIf="groupedService.isAppointmentBooked" class="footer-row">
                                    <div class="status-icon">
                                        <img *ngIf="groupedService.utilisedRatio === 1"
                                            src="assets/icons/health-package/check.svg" />
                                        <img *ngIf="groupedService.utilisedRatio !== 1"
                                            src="assets/icons/calendar-simple.svg" />
                                    </div>

                                    <div class="appt-date">{{groupedService.firstService?.startDate | moment : 'D MMM YYYY, hh:mm a' : 'YYYY-MM-DD'}}
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                </div>
                <!-- <div class="cancel-footer">
                    <button class="btn-cancel-package" (click)="onCancelPackage()">
                        {{ 'Cancel_package' | translate }}
                    </button>
                </div> -->
            </section>
        </div>
    </div>
</div>

<app-service-included *ngIf="showServiceIncludedModal" [selectedPackage]="selectedPackage" [groupedService]="selectedGrpService" [isServiceIncluded]="true" (click)="closeServiceModal()"></app-service-included>


<app-consultation-type-modal *ngIf="openConsultationTypeSelection"   (close)="handleClose()" (confirm)="handleConfirm($event)"></app-consultation-type-modal>


<app-health-package-flow *ngIf="openHealthPkgs" [subsequentApptBooking]="bookSubsequentAppt" [modeOfService]="modeOfService" [options]="options" (close)="closeHealthPkg()" (action)="redirectToMyPackage($event)" [pkgdetails]="selectedPackage?.packageDtls" [selectedPackage]="selectedPackage" [flowType]="'BOOKSUBSERVICE'" [isMultiplePractCode]="isMultiplePractCode" [subserviceWithResource]="subserviceWithResource"></app-health-package-flow>